// extracted by mini-css-extract-plugin
export default {"label":"StateDropdownSelector-module__label--QHJKb"};